import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, normalizeClass as _normalizeClass, withModifiers as _withModifiers, withKeys as _withKeys } from "vue";
const _hoisted_1 = {
  class: "aiScenarioSelectorContainer"
};
const _hoisted_2 = {
  key: 0,
  class: "loadingState"
};
const _hoisted_3 = {
  class: "loadingMessage"
};
const _hoisted_4 = {
  class: "loadingSubMessage"
};
const _hoisted_5 = {
  key: 1,
  class: "errorState"
};
const _hoisted_6 = {
  class: "errorTitle"
};
const _hoisted_7 = {
  class: "errorSubtitle"
};
const _hoisted_8 = {
  class: "errorActions"
};
const _hoisted_9 = {
  key: 2,
  class: "loadedState"
};
const _hoisted_10 = {
  class: "titleText"
};
const _hoisted_11 = {
  class: "subtitleText"
};
const _hoisted_12 = {
  class: "rolesRecap"
};
const _hoisted_13 = {
  class: "rolesRecapLabel"
};
const _hoisted_14 = {
  class: "rolesRecapChips"
};
const _hoisted_15 = {
  class: "scenariosHeader"
};
const _hoisted_16 = {
  class: "scenariosTitle"
};
const _hoisted_17 = {
  key: 0,
  class: "regenLoader"
};
const _hoisted_18 = {
  class: "regenText"
};
const _hoisted_19 = {
  key: 1,
  class: "scenariosList"
};
const _hoisted_20 = ["onClick"];
const _hoisted_21 = {
  key: 0,
  class: "scenarioCheck"
};
const _hoisted_22 = {
  class: "scenarioInner"
};
const _hoisted_23 = {
  class: "scenarioIconWrap"
};
const _hoisted_24 = {
  class: "scenarioBody"
};
const _hoisted_25 = {
  class: "scenarioTitle"
};
const _hoisted_26 = {
  class: "scenarioDesc"
};
const _hoisted_27 = {
  key: 0,
  class: "scenarioRefs"
};
const _hoisted_28 = {
  key: 2,
  class: "customScenariosSection"
};
const _hoisted_29 = {
  class: "customScenariosLabel"
};
const _hoisted_30 = {
  class: "scenariosList"
};
const _hoisted_31 = ["onClick"];
const _hoisted_32 = {
  key: 0,
  class: "scenarioCheck"
};
const _hoisted_33 = {
  class: "scenarioInner"
};
const _hoisted_34 = {
  class: "scenarioIconWrap"
};
const _hoisted_35 = {
  class: "scenarioBody"
};
const _hoisted_36 = {
  class: "scenarioTitle"
};
const _hoisted_37 = {
  key: 0,
  class: "scenarioDesc"
};
const _hoisted_38 = ["onClick"];
const _hoisted_39 = {
  key: 3,
  class: "addCustomScenarioSection"
};
const _hoisted_40 = {
  class: "customScenariosLabel"
};
const _hoisted_41 = {
  class: "addCustomScenarioRow"
};
const _hoisted_42 = {
  key: 3,
  class: "bottomLineButton"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Loader = _resolveComponent("Loader");
  const _component_el_skeleton = _resolveComponent("el-skeleton");
  const _component_icon = _resolveComponent("icon");
  const _component_standard_button = _resolveComponent("standard-button");
  const _component_el_tag = _resolveComponent("el-tag");
  const _component_el_input = _resolveComponent("el-input");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_ctx.loading ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createVNode(_component_Loader, {
    "spinner-size": "spinnersLarge"
  }), _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('aiSpeachGenerator.roleBased.scenarioSelector.loading')), 1), _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('aiSpeachGenerator.roleBased.scenarioSelector.loadingSubtitle')), 1), _createVNode(_component_el_skeleton, {
    rows: 5,
    animated: "",
    class: "loadingSkeleton"
  })])) : _ctx.errorState ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createVNode(_component_icon, {
    icon: "alert-circle-outline",
    size: "huge",
    color: "danger"
  }), _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('aiSpeachGenerator.roleBased.scenarioSelector.errorTitle')), 1), _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t('aiSpeachGenerator.roleBased.scenarioSelector.error')), 1), _createElementVNode("div", _hoisted_8, [_createVNode(_component_standard_button, {
    outlined: true,
    onAction: _ctx.onBack
  }, {
    default: _withCtx(() => [_createVNode(_component_icon, {
      icon: "arrow-left"
    }), _createTextVNode(" " + _toDisplayString(_ctx.$t('aiSpeachGenerator.roleBased.back')), 1)]),
    _: 1
  }, 8, ["onAction"]), _createVNode(_component_standard_button, {
    onAction: _ctx.loadScenarios
  }, {
    default: _withCtx(() => [_createVNode(_component_icon, {
      icon: "refresh"
    }), _createTextVNode(" " + _toDisplayString(_ctx.$t('aiSpeachGenerator.roleBased.scenarioSelector.retry')), 1)]),
    _: 1
  }, 8, ["onAction"])])])) : (_openBlock(), _createElementBlock("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t('aiSpeachGenerator.roleBased.scenarioSelector.title')), 1), _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.$t('aiSpeachGenerator.roleBased.scenarioSelector.subtitle')), 1), _createElementVNode("div", _hoisted_12, [_createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.$t('aiSpeachGenerator.roleBased.scenarioSelector.rolesRecap')), 1), _createElementVNode("div", _hoisted_14, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.roles, role => {
    return _openBlock(), _createElementBlock("div", {
      key: role.id,
      class: "rolesRecapChip"
    }, [_createVNode(_component_icon, {
      icon: "account-outline",
      class: "rolesRecapChipIcon"
    }), _createElementVNode("span", null, _toDisplayString(role.title), 1)]);
  }), 128))])]), _createElementVNode("div", _hoisted_15, [_createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.$t('aiSpeachGenerator.roleBased.scenarioSelector.scenariosTitle')), 1), !_ctx.regenerating && _ctx.regenerateRemaining > 0 ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "regenerateAction",
    onClick: _cache[0] || (_cache[0] =
    //@ts-ignore
    (...args) => _ctx.onRegenerate && _ctx.onRegenerate(...args))
  }, [_createVNode(_component_icon, {
    icon: "refresh"
  }), _createTextVNode(" " + _toDisplayString(_ctx.$t('aiSpeachGenerator.roleBased.picker.regenerate')), 1)])) : _createCommentVNode("", true)]), _ctx.regenerating ? (_openBlock(), _createElementBlock("div", _hoisted_17, [_createVNode(_component_Loader, {
    "spinner-size": "spinnersNormal"
  }), _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.$t('aiSpeachGenerator.roleBased.picker.regenerating')), 1)])) : (_openBlock(), _createElementBlock("div", _hoisted_19, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.scenarios, scenario => {
    return _openBlock(), _createElementBlock("div", {
      key: scenario.id,
      class: _normalizeClass(["scenarioCard", {
        'scenarioCardSelected': _ctx.selectedScenarioId === scenario.id
      }]),
      onClick: $event => _ctx.selectScenario(scenario.id)
    }, [_ctx.selectedScenarioId === scenario.id ? (_openBlock(), _createElementBlock("div", _hoisted_21, [_createVNode(_component_icon, {
      icon: "check"
    })])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_22, [_createElementVNode("div", _hoisted_23, [_createVNode(_component_icon, {
      icon: "movie-open-outline",
      size: "large",
      color: _ctx.selectedScenarioId === scenario.id ? 'primary' : 'light2'
    }, null, 8, ["color"])]), _createElementVNode("div", _hoisted_24, [_createElementVNode("div", _hoisted_25, _toDisplayString(scenario.title), 1), _createElementVNode("div", _hoisted_26, _toDisplayString(scenario.description), 1), scenario.documentRefs && scenario.documentRefs.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_27, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(scenario.documentRefs, (ref, idx) => {
      return _openBlock(), _createBlock(_component_el_tag, {
        key: idx,
        size: "small",
        type: "info",
        effect: "plain",
        class: "scenarioRefTag"
      }, {
        default: _withCtx(() => [_createVNode(_component_icon, {
          icon: "file-document-outline",
          size: "small"
        }), _createTextVNode(" " + _toDisplayString(_ctx.getDocumentName(ref.documentIndex)) + " · " + _toDisplayString(_ctx.formatPages(ref.pages)), 1)]),
        _: 2
      }, 1024);
    }), 128))])) : _createCommentVNode("", true)])])], 10, _hoisted_20);
  }), 128))])), !_ctx.regenerating && _ctx.customScenarios.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_28, [_createElementVNode("div", _hoisted_29, _toDisplayString(_ctx.$t('aiSpeachGenerator.roleBased.scenarioSelector.customScenariosLabel')), 1), _createElementVNode("div", _hoisted_30, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.customScenarios, scenario => {
    return _openBlock(), _createElementBlock("div", {
      key: scenario.id,
      class: _normalizeClass(["scenarioCard customScenarioCard", {
        'scenarioCardSelected': _ctx.selectedScenarioId === scenario.id
      }]),
      onClick: $event => _ctx.selectScenario(scenario.id)
    }, [_ctx.selectedScenarioId === scenario.id ? (_openBlock(), _createElementBlock("div", _hoisted_32, [_createVNode(_component_icon, {
      icon: "check"
    })])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_33, [_createElementVNode("div", _hoisted_34, [_createVNode(_component_icon, {
      icon: "lightbulb-on-outline",
      size: "large",
      color: _ctx.selectedScenarioId === scenario.id ? 'primary' : 'light2'
    }, null, 8, ["color"])]), _createElementVNode("div", _hoisted_35, [_createElementVNode("div", _hoisted_36, [_createTextVNode(_toDisplayString(scenario.title) + " ", 1), _createVNode(_component_el_tag, {
      size: "small",
      type: "info",
      effect: "plain",
      class: "customBadge"
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('aiSpeachGenerator.roleBased.scenarioSelector.customBadge')), 1)]),
      _: 1
    })]), scenario.description ? (_openBlock(), _createElementBlock("div", _hoisted_37, _toDisplayString(scenario.description), 1)) : _createCommentVNode("", true)]), _createElementVNode("div", {
      class: "scenarioRemove",
      onClick: _withModifiers($event => _ctx.removeCustomScenario(scenario.id), ["stop"])
    }, [_createVNode(_component_icon, {
      icon: "close",
      size: "small"
    })], 8, _hoisted_38)])], 10, _hoisted_31);
  }), 128))])])) : _createCommentVNode("", true), !_ctx.regenerating ? (_openBlock(), _createElementBlock("div", _hoisted_39, [_createElementVNode("div", _hoisted_40, _toDisplayString(_ctx.$t('aiSpeachGenerator.roleBased.scenarioSelector.addCustomLabel')), 1), _createElementVNode("div", _hoisted_41, [_createVNode(_component_el_input, {
    modelValue: _ctx.customScenarioInput,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _ctx.customScenarioInput = $event),
    size: "large",
    placeholder: _ctx.$t('aiSpeachGenerator.roleBased.scenarioSelector.addCustomPlaceholder'),
    onKeyup: _withKeys(_ctx.addCustomScenario, ["enter"]),
    clearable: ""
  }, null, 8, ["modelValue", "placeholder", "onKeyup"]), _createVNode(_component_standard_button, {
    outlined: true,
    onAction: _ctx.addCustomScenario,
    disabled: !_ctx.customScenarioInput.trim()
  }, {
    default: _withCtx(() => [_createVNode(_component_icon, {
      icon: "plus"
    }), _createTextVNode(" " + _toDisplayString(_ctx.$t('aiSpeachGenerator.roleBased.scenarioSelector.addCustomButton')), 1)]),
    _: 1
  }, 8, ["onAction", "disabled"])])])) : _createCommentVNode("", true)])), !_ctx.loading && !_ctx.errorState ? (_openBlock(), _createElementBlock("div", _hoisted_42, [_createVNode(_component_standard_button, {
    outlined: true,
    onAction: _ctx.onBack
  }, {
    default: _withCtx(() => [_createVNode(_component_icon, {
      icon: "arrow-left"
    }), _createTextVNode(" " + _toDisplayString(_ctx.$t('aiSpeachGenerator.roleBased.back')), 1)]),
    _: 1
  }, 8, ["onAction"]), _createVNode(_component_standard_button, {
    disabled: !_ctx.selectedScenarioId || _ctx.regenerating,
    onAction: _ctx.onValidate
  }, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('aiSpeachGenerator.roleBased.scenarioSelector.generateButton')) + " ", 1), _createVNode(_component_icon, {
      icon: "arrow-right"
    })]),
    _: 1
  }, 8, ["disabled", "onAction"])])) : _createCommentVNode("", true)]);
}